<template>
  <div class="container">
    <a-carousel
      v-if="isInitState && advertisementList.length > 0"
      class="advertise_carousel"
      autoplay
      :autoplaySpeed="5000"
    >
      <div v-for="(item, index) in advertisementList" :key="index">
        <img
          :src="item.mediaUrl || '@/assets/images/workplace_theater.svg'"
          @click="handleOpenAdvertisement(item)"
          :style="{ cursor: item.link ? 'pointer' : 'default' }"
          alt=""
          class="advertise_img"
        />
      </div>
    </a-carousel>
    <div v-if="!isInitState" class="search_wrapper">
      <div class="search">
        <div class="auto-complete-textarea">
          <div v-if="filterForm.fileName" class="file_wrapper">
            <img src="@/assets/images/fileJD.svg" class="file_img" @click="handleOpenFileJD" />
            <div class="file_info" @click="handleOpenFileJD">
              <div class="file_name">{{ filterForm.fileName }}</div>
              <div class="file_status">
                <span v-if="filterForm.status == 'success'">Successfully identified</span>
                <span v-else-if="filterForm.status == 'error'" style="color:#F04646;">Content recognition failure</span>
                <span v-else-if="filterForm.status == 'loading'">Running...</span>
              </div>
            </div>
            <div class="file_action">
              <img
                v-if="filterForm.status == 'error' || filterForm.status == 'success'"
                src="@/assets/images/deleteJD.svg"
                alt=""
                class="file_action_icon"
                @click="handleDeleteJDFile"
              />
              <img
                v-else-if="filterForm.status == 'loading'"
                src="@/assets/images/loading.svg"
                alt=""
                class="file_action_icon loading_icon"
              />
            </div>
          </div>
          <a-textarea
            v-model:value="filterForm.words"
            name="search"
            :placeholder="searchPlaceholder"
            :auto-size="{ minRows: 1, maxRows: 1 }"
            class="search_input"
            @input="onInput"
            @keydown="handleKeydown"
          />
          <ul v-if="showSuggestions" class="suggestions_list" ref="suggestionsRef">
            <li v-for="item in suggestions.slice(0, 10)" :key="item.job" @click="selectSuggestion(item)">
              <span class="skill">{{ item.job }}</span>
              <span class="position">{{ item.industry }}</span>
            </li>
          </ul>
        </div>
        <img src="@/assets/images/search.svg" alt="" class="search_icon" @click="handleInitSearch()" />
        <div class="search_actions">
          <a-tooltip placement="top">
            <template #title>
              <span>Click to select a position or skill</span>
            </template>
            <div class="choose_btn" @click="handleOpenPositionModal">
              <img src="@/assets/images/choose.svg" alt="" class="choose_icon" />
              <span>Choose role</span>
            </div>
          </a-tooltip>
          <a-tooltip placement="top">
            <template #title>
              <span>Upload your JD (Job Description) image, and AI will match it for you.</span>
            </template>
            <div class="upload_btn" @click="handleUploadClickJD">
              <img src="@/assets/images/upload.svg" alt="" class="upload_icon" />
              <span>Upload JD</span>
              <input type="file" ref="jdInputJD" style="display:none" @change="handleFileChangeJD" />
            </div>
          </a-tooltip>
        </div>
      </div>
    </div>
    <div class="talent_wrapper">
      <div v-show="isShowMask" class="mask"></div>
      <div v-show="resumeList.length > 0">
        <!-- <div class="title">
          <img src="@/assets/images/talent.svg" alt="" class="title_icon" />
          Talents Overview
        </div> -->
        <div class="filter_wrapper">
          <a-select
            class="filter_select"
            v-model:value="filterForm.activity"
            size="large"
            :popupClassName="'filter_select_dropdown'"
            @change="getResumeList"
          >
            <a-select-option value="">Activity</a-select-option>
            <a-select-option value="Any time">Any time</a-select-option>
            <a-select-option value="Post month">Active within 30 days</a-select-option>
            <a-select-option value="Post three months">Active within 3 months</a-select-option>
          </a-select>
          <!-- <CityInputItem @on-change="handleChangeCity" class="filter_select" /> -->
          <div class="filter_select video_select">
            <a-checkbox v-model:checked="filterForm.hasVideo" @change="getResumeList">Includes videos</a-checkbox>
          </div>
        </div>
        <div class="waterfall_wrapper">
          <div v-if="isShowAddResume && !isMobileView" class="grid_item" @click="handleOpenResumeGuideModal">
            <div class="resume_card add_card">
              <div class="add_icon_wrapper">
                <img src="@/assets/images/add.svg" alt="" class="add_icon" />
              </div>
              <div class="description">
                <img src="@/assets/images/ai_resume.svg" alt="" class="ai_icon" />
                AI Resume
              </div>
            </div>
          </div>
          <div
            v-for="(item, index) in resumeList"
            class="grid_item"
            :key="item.resumeId"
            @click="handleOpenRusumeDetail(item)"
          >
            <div class="resume_card">
              <div class="info_wrapper">
                <div class="info">
                  <div class="name">{{ item.displayName }}</div>
                  <div class="type">{{ item.jobStatus }}<span style="margin: 0 4px;">|</span>{{ item.city }}</div>
                </div>
                <img :src="item.headUrl || ''" alt="" class="avatar" crossorigin="anonymous" @error="setDefaultImage" />
              </div>
              <div class="tag_wrapper">
                <div
                  class="tag"
                  v-for="(tag, index) in item.skillList.slice(0, 4)"
                  :key="index"
                  :class="{ 'tag-job': isJobTag(tag), 'tag-skill': !isJobTag(tag) }"
                >
                  {{ tag }}
                </div>
              </div>
              <div class="introduce">
                {{ item.advantage }}
              </div>
              <div v-if="item.videoList && item.videoList.length" class="video_wrapper">
                <div class="title">
                  <img src="@/assets/images/camera.svg" alt="" class="camera_icon" />
                  Skill videos
                </div>
                <div class="video_card_container">
                  <video
                    oncontextmenu="return false;"
                    :src="playSrc(item.videoList[0])"
                    :id="'videoPlayer' + index"
                    class="video_player"
                    muted
                    @click.stop="handleInitVideoView(item.videoList, 0)"
                    @loadedmetadata="getVideoDuration(index)"
                    playsinline
                    webkit-playsinline
                    preload="metadata"
                    @play="handleCoverPlaying(item.videoList[0].videoUrl, true)"
                    @pause="handleCoverPlaying(item.videoList[0].videoUrl, false)"
                    @mouseenter="handleMouseEnter($event)"
                    @mouseleave="handleMouseLeave($event)"
                  ></video>
                  <img
                    v-if="getCoverSrc(item.videoList[0])"
                    :src="getCoverSrc(item.videoList[0])"
                    class="video_cover_img"
                    :class="{
                      video_cover_hidden: playingMap[item.videoList[0].videoUrl],
                      video_cover_default: isDefaultCover(item.videoList[0]),
                    }"
                  />
                  <span v-show="videoDurationList[index]" class="video_duration">
                    {{ formatToMinutes(videoDurationList[index]) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="resumeList.length == 0 && !isLoading && hasSearched" class="not_data_wrapper">
        <img src="@/assets/images/no_data.svg" alt="No Data" />
        <div class="not_data_content">No results found for this city</div>
        <div class="back_btn" @click="handleReloadPage()">
          Back
        </div>
      </div>
      <!-- 接口失败兜底：避免首屏简历区整块留白，提供显式重试入口 -->
      <div v-show="loadError && !isLoading" class="not_data_wrapper">
        <div class="not_data_content">Failed to load resumes, please try again</div>
        <div class="back_btn" @click="getResumeList()">
          Retry
        </div>
      </div>
      <a-spin class="index_loading" :spinning="isLoading" :indicator="indicator" tip="Loading..." />
    </div>
    <a-modal
      class="resume_detail_modal"
      v-model:open="resumeModalVisible"
      title=""
      @cancel="resumeModalVisible = false"
      width="800px"
      :footer="null"
    >
      <ResumePreview
        v-if="resumeModalVisible"
        ref="ResumePreviewRef"
        :resumeToken="resumePreviewToken"
        :isShowAction="true"
      />
    </a-modal>
    <ResumeGuideModal ref="ResumeGuideModalRef" />
    <PositionModal ref="PositionModalRef" @select-item="handleSelectSkill" />
    <VideoViewer ref="VideoViewerRef" />
  </div>
</template>

<script setup>
import { LoadingOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { computed, ref, reactive, onMounted, onBeforeUnmount, toRaw, h, nextTick, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

import { fetchCategoryList, upload, fetchCurrentCity } from '@/api/common.js';
import { fetchResumeList, fetchResumeListByToken, fetchAdvertisementList } from '@/api/home.js';
import CityInputItem from '@/components/CityInputItem.vue';
import PositionModal from '@/components/PositionModal.vue';
import ResumeGuideModal from '@/components/ResumeGuideModal.vue';
import ResumePreview from '@/components/ResumePreview.vue';
import VideoViewer from '@/components/VideoViewer.vue';
import { playSrc, posterSrc } from '@/utils/vod.js';

const route = useRoute();
const store = useStore();

const indicator = h(LoadingOutlined, {
  style: {
    fontSize: '24px',
    color: '#05644f',
  },
  spin: true,
});

const handleReloadPage = () => {
  window.location.reload();
};

const isShowAddResume = computed(
  () => !(store.state.currentAccount.score > 0 || store.state.currentAccount.type != 'seeker')
);

// 手机端（与 640px 断点一致）不渲染"添加简历"引导卡片，瀑布流不留空位
const mobileMq = window.matchMedia('(max-width: 640px)');
const isMobileView = ref(mobileMq.matches);
const handleMobileMqChange = () => {
  isMobileView.value = mobileMq.matches;
};
if (typeof mobileMq.addEventListener === 'function') {
  mobileMq.addEventListener('change', handleMobileMqChange);
} else if (typeof mobileMq.addListener === 'function') {
  mobileMq.addListener(handleMobileMqChange); // 旧内核兼容
}
onBeforeUnmount(() => {
  if (typeof mobileMq.removeEventListener === 'function') {
    mobileMq.removeEventListener('change', handleMobileMqChange);
  } else if (typeof mobileMq.removeListener === 'function') {
    mobileMq.removeListener(handleMobileMqChange);
  }
  // 清理 resize 监听
  window.removeEventListener('resize', handleResize);
  window.removeEventListener('orientationchange', handleResize);
  if (resizeTimer) {
    clearTimeout(resizeTimer);
    resizeTimer = null;
  }
  // 销毁 Masonry 实例
  if (msnry) {
    msnry.destroy();
    msnry = null;
  }
});
watch(isMobileView, () => {
  nextTick(() => {
    initWaterfall();
  });
});

watch(isShowAddResume, () => {
  nextTick(() => {
    initWaterfall();
  });
});

const resumeModalVisible = ref(false);
const resumePreviewToken = ref('');
const resumeId = ref('');
const handleOpenRusumeDetail = (item) => {
  resumeModalVisible.value = true;
  resumePreviewToken.value = item.token;
  resumeId.value = item.resumeId;
};

const showSuggestions = ref(false);
const suggestions = ref([]);
const autoCompleteOptions = ref([]);

const isInitState = computed(() => store.state.isStoreInitState);
const isShowTips = computed(() => store.state.isShowTips);

// 标记是否已经执行过搜索
const hasSearched = ref(false);
// 简历列表接口失败标记：失败时展示重试区块，避免列表区整块留白
const loadError = ref(false);
const filterForm = reactive({
  skill: '',
  city: '',
  location: '',
  hasVideo: false,
  activity: '',
  words: '',
  fileName: '',
  status: '',
  fileType: '',
  fileUrl: '',
  pageSize: 30,
  pageNum: 1,
});

// 处理URL参数中的搜索关键词
const handleSearchFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const search = urlParams.get('search');
  if (search) {
    filterForm.words = search;
    handleInitSearch();
  } else {
    // 如果URL中没有search参数，确保处于初始状态
    store.state.isStoreInitState = true;
  }
};

onMounted(() => {
  handleSearchFromUrl();
});

// 监听路由变化，当URL参数变化时重新执行搜索
watch(
  () => route.query,
  () => {
    handleSearchFromUrl();
  }
);

// 监听isInitState的变化，当它变为true时清除搜索内容并重新加载初始内容
watch(isInitState, (newVal) => {
  if (newVal) {
    // 清除搜索内容
    filterForm.words = '';
    filterForm.fileName = '';
    filterForm.status = '';
    filterForm.fileType = '';
    filterForm.fileUrl = '';
    // 清除搜索结果
    resumeList.value = [];
    resumeToken.value = [];
    videoDurationList.value = [];
    // 重置搜索标志
    hasSearched.value = false;
    // 重新加载初始内容
    getResumeList();
  }
});

// 监听路由变化，当路由回到首页时重新初始化瀑布流布局
watch(
  () => route.path,
  (newPath) => {
    if (newPath === '/index' || newPath.startsWith('/index/')) {
      nextTick(() => {
        initWaterfall();
      });
    }
  }
);
const onInput = () => {
  showSuggestions.value = true;
  suggestions.value = autoCompleteOptions.value.filter((option) =>
    option.job.toLowerCase().includes(filterForm.words.toLowerCase())
  );
};
const handleKeydown = (event) => {
  if (event.key === 'Enter') {
    event.preventDefault();
    handleInitSearch();
  }
};
const handleInitSearch = () => {
  if (filterForm.words || filterForm.fileUrl) {
    isLoading.value = true;
    hasSearched.value = true; // 标记已执行搜索
    getResumeList();
    store.state.isStoreInitState = false;
  } else {
    message.error('Please enter your content first.');
  }
};

const selectSuggestion = (item) => {
  filterForm.words = item.job + ' ' + item.industry + '\n';
  getResumeList();
};

const getCategoryList = () => {
  autoCompleteOptions.value = [
    ...store.state.categoryList.jobList.map((item) => ({
      job: item.job,
      industry: item.industry,
    })),
    ...store.state.categoryList.skillList.map((skill) => ({
      job: skill,
      industry: '',
    })),
  ];
};

watch(
  () => store.state.categoryList,
  () => {
    getCategoryList();
  },
  { immediate: true }
);

const PositionModalRef = ref(null);
const handleOpenPositionModal = () => {
  PositionModalRef.value.open('isIndexSearch');
};
const handleSelectSkill = (item) => {
  filterForm.words = item.categoryName;
  store.state.isStoreInitState = false;
  getResumeList();
};

const ResumeGuideModalRef = ref(null);
const handleOpenResumeGuideModal = () => {
  if (store.getters.isAuthenticated) {
    ResumeGuideModalRef.value.open();
  } else {
    handleInitLoginModal();
  }
};
const handleInitLoginModal = () => {
  document.getElementsByClassName('login')[0].click();
};

const isLoading = ref(false);
const resumeToken = ref([]);
const resumeList = ref([]);
const getResumeList = () => {
  filterForm.pageNum = 1;
  showSuggestions.value = false;
  isLoading.value = true;
  loadError.value = false;
  fetchResumeList(filterForm)
    .then((res) => {
      if (res.code == 0) {
        resumeToken.value = res.data;
        filterForm.status = 'success';
        getResumeListByToken();
      } else if (res.code == 30001) {
        filterForm.status = 'error';
        isLoading.value = false;
        loadError.value = true;
      } else {
        isLoading.value = false;
        loadError.value = true;
      }
    })
    .catch(() => {
      isLoading.value = false;
      loadError.value = true;
    });
};

const getResumeListByToken = (type) => {
  isLoading.value = true;
  let resumeTokenValue = [];
  if (type == 'scroll') {
    resumeTokenValue = resumeToken.value.slice(
      filterForm.pageSize * (filterForm.pageNum - 1),
      filterForm.pageSize * filterForm.pageNum
    );
  } else {
    resumeTokenValue = resumeToken.value.slice(0, filterForm.pageSize * filterForm.pageNum);
  }
  fetchResumeListByToken({ pageSize: filterForm.pageSize, pageNum: filterForm.pageNum, tokens: resumeTokenValue })
    .then((res) => {
      if (res.code === 0 && res.data) {
        res.data.list.forEach((item) => {
          if (item.videoList && item.videoList.length > 0) {
            ensureCover(item.videoList[0]);
          }
        });
        if (type == 'scroll') {
          resumeList.value.push(...res.data.list);
          videoDurationList.value.push(...res.data.list.map(() => ''));
          nextTick(() => {
            window.scrollTo(0, currentScroll.value);
            initWaterfall();
          });
        } else {
          isShowMask.value = true;
          resumeList.value = res.data && res.data.list;
          const newDurations = res.data.list.map(() => '');
          videoDurationList.value = videoDurationList.value.concat(newDurations);
          loadError.value = false;
          nextTick(() => {
            initWaterfall();
          });
        }
      } else if (type != 'scroll') {
        // 首页首屏加载失败才展示整页重试态；分页滚动失败保留已加载内容
        loadError.value = true;
      }
      isLoading.value = false;
    })
    .catch(() => {
      isLoading.value = false;
      if (type != 'scroll') {
        loadError.value = true;
      }
    });
};

const setDefaultImage = (event) => {
  event.target.src = require('@/assets/images/avatar.svg');
};

const handleChangeCity = (item) => {
  filterForm.city = item;
  getResumeList();
};

const searchPlaceholder = ref('Enter job position or skills');
const jdInputJD = ref(null);
const handleUploadClickJD = () => {
  jdInputJD.value && jdInputJD.value.click();
};
const handleFileChangeJD = (e) => {
  const file = e.target.files[0];
  if (!file) return;
  const formData = new FormData();
  formData.append('file', file);
  formData.append('folder', 1);
  filterForm.fileName = file.name;
  filterForm.fileType = file.type;
  filterForm.status = 'loading';
  upload(formData).then((res) => {
    if (res.code === 0) {
      filterForm.fileUrl = res.data.fileUrl;
      getResumeList();
      searchPlaceholder.value = 'Please conduct a matching search based on my JD';
    } else {
      filterForm.status = 'error';
      message.error(res.msg);
    }
  });
};
const handleDeleteJDFile = () => {
  filterForm.fileName = '';
  filterForm.status = '';
  filterForm.fileType = '';
  filterForm.fileUrl = '';
  jdInputJD.value.files = new DataTransfer().files;
  searchPlaceholder.value = 'Enter job position or skills';
  getResumeList();
};
const handleOpenFileJD = () => {
  if (filterForm.fileUrl) {
    window.open(filterForm.fileUrl, '_blank');
  } else {
    message.error('No JD file uploaded.');
  }
};

const suggestionsRef = ref(null);
const handleClickOutside = (event) => {
  if (suggestionsRef.value && !suggestionsRef.value.contains(event.target)) {
    showSuggestions.value = false;
  }
};

const VideoViewerRef = ref(null);
const handleInitVideoView = (videoList, index) => {
  VideoViewerRef.value.openViewer(videoList, index);
};
const handleMouseEnter = (event) => {
  const video = event.target;
  video.muted = true;
  if (video.readyState >= 1) {
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch((error) => {
        console.warn('Video play interrupted or failed:', error.message);
      });
    }
  }
};

const handleMouseLeave = (event) => {
  const video = event.target;
  video.pause();
};

// ===== 视频封面：截帧加载去重 + 失败重试 + 默认图兜底 =====
const defaultCover = require('@/assets/images/video.svg');
const COVER_MAX_RETRIES = 3; // 共尝试 4 次
const COVER_RETRY_DELAYS = [2000, 4000, 8000];
// key 为截帧 URL：loading 加载中 / ok 成功 / error 显示默认图
const coverStateMap = reactive({});
// hover 正在播放的视频（key 为视频 URL），播放时隐藏封面图
const playingMap = reactive({});
// 同一截帧 URL 全局共用一个加载 Promise，避免重复请求
const coverPromiseCache = new Map();
let isPageAlive = true;

const getSnapshotUrl = (videoUrl) => `${videoUrl}?x-oss-process=video/snapshot,t_1000,f_jpg,w_500,ar_auto`;

const loadImageOnce = (url) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => reject();
    img.src = url;
  });

const ensureCover = (item) => {
  if (!item) return;
  if (item.coverUrl) return;
  const videoUrl = playSrc(item);
  if (!videoUrl || videoUrl.includes('.m3u8')) return;
  const snapshotUrl = getSnapshotUrl(videoUrl);
  if (coverPromiseCache.has(snapshotUrl)) return coverPromiseCache.get(snapshotUrl);
  coverStateMap[snapshotUrl] = 'loading';
  const task = (async () => {
    for (let i = 0; i <= COVER_MAX_RETRIES; i++) {
      try {
        await loadImageOnce(snapshotUrl);
        if (isPageAlive) coverStateMap[snapshotUrl] = 'ok';
        return;
      } catch (error) {
        if (i < COVER_MAX_RETRIES) {
          await new Promise((resolve) => setTimeout(resolve, COVER_RETRY_DELAYS[i]));
        }
      }
    }
    if (isPageAlive) coverStateMap[snapshotUrl] = 'error';
  })();
  coverPromiseCache.set(snapshotUrl, task);
  return task;
};

const getCoverSrc = (item) => {
  if (!item) return '';
  if (item.coverUrl) return item.coverUrl;
  const poster = posterSrc(item);
  if (!poster) return '';
  const state = coverStateMap[poster];
  if (state === 'ok') return poster;
  if (state === 'error') return defaultCover;
  return '';
};

const isDefaultCover = (item) => {
  if (!item || item.coverUrl) return false;
  const src = playSrc(item);
  return !!src && coverStateMap[getSnapshotUrl(src)] === 'error';
};

const handleCoverPlaying = (videoUrl, isPlaying) => {
  playingMap[videoUrl] = isPlaying;
};

onBeforeUnmount(() => {
  isPageAlive = false;
});

const videoDurationList = ref([]);
const getVideoDuration = (index) => {
  const duration = document.getElementById('videoPlayer' + index).duration;
  videoDurationList.value[index] = duration;
};
const formatToMinutes = (seconds) => {
  const totalSeconds = Math.floor(seconds);
  const minutes = Math.floor(totalSeconds / 60);
  const remainingSeconds = totalSeconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};

// 判断标签是否为岗位标签（以后端分类表为准：jobList 中的为岗位，skillList 中的为岗位下技能）
const isJobTag = (tag) => {
  const jobNames = (store.state.categoryList.jobList || []).map((item) => item.job.trim().toLowerCase());
  const skillNames = (store.state.categoryList.skillList || []).map((skill) => skill.trim().toLowerCase());
  const normalizedTag = tag.trim().toLowerCase();

  // 命中岗位表 -> 岗位；命中技能表 -> 技能；
  // 均未命中时为用户手动输入的自定义项（仅岗位支持自定义输入），按岗位展示
  if (jobNames.includes(normalizedTag)) {
    return true;
  }
  if (skillNames.includes(normalizedTag)) {
    return false;
  }
  return true;
};

const advertisementList = ref([]);
const getAdvertisementList = () => {
  fetchAdvertisementList().then((res) => {
    if (res.code == 0) {
      advertisementList.value = res.data;
    } else {
      message.error(res.msg);
    }
  });
};

const handleOpenAdvertisement = (item) => {
  if (item.link) {
    window.open(item.link, '_blank');
  }
};

// 城市选择通过 CityInputItem 组件处理，不在页面加载时自动定位
// 如需自动定位功能，可在 CityInputItem 中点击"当前城市"使用

const isShowMask = ref(false);
const currentScroll = ref(0);

const handleScroll = () => {
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  const windowHeight = window.innerHeight;
  const documentHeight = document.documentElement.scrollHeight;
  if (
    scrollTop + windowHeight >= documentHeight &&
    !isLoading.value &&
    resumeToken.value.length >= filterForm.pageSize * filterForm.pageNum
  ) {
    currentScroll.value = scrollTop;
    filterForm.pageNum++;
    getResumeListByToken('scroll');
  }
};

// Masonry 实例（模块级），方便 resize 时调用 layout/destroy
let msnry = null;

// resize 节流：视口变化时重建 Masonry（新断点会改 grid_item 百分比宽度，需重新 init 才能正确计算列数）
let resizeTimer = null;
const handleResize = () => {
  if (resizeTimer) clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    nextTick(() => {
      initWaterfall();
    });
  }, 150);
};

const initWaterfall = () => {
  // 先获取容器元素
  const container = document.querySelector('.waterfall_wrapper');
  if (!container) return;

  // 给所有卡片设置初始的最小高度，减少布局跳动
  const gridItems = container.querySelectorAll('.grid_item');
  gridItems.forEach((item) => {
    item.style.minHeight = '400px';
  });

  // 收集图片用于加载监听。头像占位交给 CSS 固定宽高（含窄屏 28px）：
  // 不能再用内联 height 占位——内联样式优先于样式表，窄屏 CSS 宽 28px ×
  // 内联高 32px 会把头像压成竖椭圆
  const images = container.querySelectorAll('img');

  // 给所有视频容器设置固定占位
  const videoContainers = container.querySelectorAll('.video_card_container');
  videoContainers.forEach((vc) => {
    vc.style.minHeight = '120px';
  });

  // 销毁旧实例（如果有），避免重复创建
  if (msnry) {
    msnry.destroy();
    msnry = null;
  }

  // eslint-disable-next-line no-undef
  msnry = new Masonry('.waterfall_wrapper', {
    itemSelector: '.grid_item',
    percentPosition: true,
  });

  // 立即隐藏遮罩层，让用户看到卡片
  isShowMask.value = false;

  // 只进行必要的重排
  // 第一次快速重排，确保初始布局正确
  setTimeout(() => {
    msnry.layout();
  }, 30);

  // 监听所有图片和视频加载
  let loadedCount = 0;
  const videos = container.querySelectorAll('video');
  const totalMedia = images.length + videos.length;

  if (totalMedia > 0) {
    const onMediaLoad = () => {
      loadedCount++;
      if (loadedCount >= totalMedia) {
        // 移除临时的最小高度限制
        gridItems.forEach((item) => {
          item.style.minHeight = '';
        });
        msnry.layout();
      }
    };

    // 处理图片加载
    images.forEach((img) => {
      if (img.complete) {
        onMediaLoad();
      } else {
        img.addEventListener('load', onMediaLoad);
        img.addEventListener('error', onMediaLoad);
      }
    });

    // 处理视频加载
    videos.forEach((video) => {
      if (video.readyState >= 1) {
        onMediaLoad();
      } else {
        video.addEventListener('loadedmetadata', onMediaLoad);
        video.addEventListener('error', onMediaLoad);
      }
    });
  }
};

onMounted(() => {
  getAdvertisementList();
  getResumeList();
  window.addEventListener('scroll', handleScroll);
  document.addEventListener('click', handleClickOutside);
  // 监听视口尺寸变化，Masonry 需重新初始化以正确应用新断点的 grid_item 百分比宽度
  window.addEventListener('resize', handleResize);
  window.addEventListener('orientationchange', handleResize);
  if (route.params.token) {
    resumeModalVisible.value = true;
    resumePreviewToken.value = route.params.token;
  }
});
</script>

<style lang="less">
.filter_wrapper {
  margin-top: 20px;
  .filter_select {
    margin-right: 15px;
    min-width: 120px;
    &:hover {
      .ant-select-arrow {
        color: #ffffff;
      }
    }
    .ant-select-selector {
      margin: 0 10px;
      border: 1px solid rgba(5, 100, 79, 0.5) !important;
      background: rgba(5, 100, 79, 0.1);
      color: #05644f;
      border-radius: 100px;
      box-shadow: none !important;
      font-size: 14px;
      height: 32px !important;
      .ant-select-selection-item {
        color: #05644f;
        text-align: center;
        line-height: 32px;
      }
      .ant-select-selection-search-input {
        height: 32px !important;
      }
    }
    .ant-select-arrow,
    .ant-select-selection-placeholder {
      color: #05644f;
    }
    .ant-select-arrow {
      margin-top: -4px;
    }
  }
  .city_select .ant-select-selection-placeholder {
    text-align: center;
  }
  .ant-select-selector:hover {
    background: #05644f;
    color: #ffffff;
    border-color: #05644f;
  }
  .ant-select-selector:hover .ant-select-selection-item,
  .ant-select-selector:hover .ant-select-selection-placeholder {
    color: #ffffff;
  }
  .video_select {
    margin-left: 10px;
    display: inline-block;
    height: 32px;
    line-height: 32px;
    text-align: center;
    border: 1px solid rgba(5, 100, 79, 0.5);
    background: rgba(5, 100, 79, 0.1);
    color: #05644f;
    border-radius: 100px;
    width: 160px;
    .ant-checkbox-wrapper {
      .ant-checkbox + span {
        color: #05644f;
        font-size: 14px;
      }
      .ant-checkbox .ant-checkbox-inner {
        border-radius: 10px;
        border-color: #05644f;
      }
      .ant-checkbox-checked:not(.ant-checkbox-disabled):after {
        border-color: #05644f !important;
        border-radius: 10px;
      }
      &:hover .ant-checkbox-inner,
      .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #05644f;
        color: #ffffff;
      }
    }
    .ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover
      .ant-checkbox-checked:not(.ant-checkbox-disabled)
      .ant-checkbox-inner {
      background-color: #05644f;
      border-radius: 10px;
    }
  }
}
.resume_detail_modal {
  position: relative;
  .ant-modal-content {
    border-radius: 20px;
  }
  .action_wrapper {
    position: absolute;
    right: -120px;
    top: 0;
    background: #b8dfc8;
    box-sizing: border-box;
    border: 1px solid rgba(5, 100, 79, 0.5);
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 100px;
    padding: 15px;
    color: #05644f;
    .item {
      text-align: center;
      cursor: pointer;
      border-top: 1px solid rgba(5, 100, 79, 0.25);
      padding: 10px 0;
      &:first-child {
        border-top: none;
      }
      p {
        margin: 10px 0;
      }
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
  .ant-modal-title {
    color: #05644f;
    font-size: 20px;
    font-weight: bold;
    line-height: normal;
  }
  .ant-modal-close-icon {
    color: #05644f;
  }
  .ant-input {
    border: 1px solid rgba(5, 100, 79, 0.5);
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
    border-radius: 16px;
    padding: 10px;
    font-size: 14px;
    color: #05644f;
  }
  .ant-input::placeholder {
    color: rgba(5, 100, 79, 0.33);
  }
  .submit_btn {
    background: #05644f;
    border-radius: 100px;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    line-height: normal;
    display: block;
    width: 100%;
    padding: 10px 20px;
    height: auto;
    margin-top: 20px;
    &:hover {
      background: #05644f;
      color: #fff;
    }
    .btn_arrow {
      margin-left: 10px;
      font-size: 18px;
    }
  }
  .resume_form {
    textarea {
      padding: 20px 20px 80px 20px;
    }
  }
}

@media (max-width: 1080px) {
  // 胶囊样式已统一收敛到 ResumePreview.vue 的 @media (max-width: 640px) 块，
  // 此处不再重复定义（避免与 ResumePreview.vue 的 640px 规则在同一断点冲突）
  .filter_wrapper {
    .filter_select {
      .ant-select-selector {
        font-size: 16px;
        line-height: 1.6;
      }
    }
    .video_select {
      .ant-checkbox-wrapper {
        .ant-checkbox + span {
          font-size: 16px;
          line-height: 1.6;
        }
      }
    }
  }
  .resume_detail_modal {
    .ant-modal-title {
      font-size: 22px;
      line-height: 1.4;
    }
    .ant-input {
      font-size: 16px;
      line-height: 1.6;
    }
    .submit_btn {
      font-size: 20px;
      line-height: 1.5;
    }
  }
  .container {
    .search_wrapper {
      .search {
        .search_input {
          font-size: 16px;
          line-height: 1.6;
        }
        .search_actions {
          .choose_btn,
          .upload_btn {
            font-size: 14px;
            line-height: 1.6;
            padding: 10px 20px;
          }
        }
      }
      .suggestions_list {
        li {
          font-size: 18px;
          line-height: 1.6;
          padding: 14px 20px;
        }
      }
    }
    .talent_wrapper {
      .title {
        font-size: 22px;
        line-height: 1.4;
      }
      .waterfall_wrapper {
        .grid_item {
          .resume_card {
            padding: 28px;
            .info_wrapper {
              .info {
                .name {
                  font-size: 16px;
                  line-height: 1.5;
                }
                .type {
                  font-size: 14px;
                  line-height: 1.5;
                }
              }
              .avatar {
                width: 40px;
                height: 40px;
              }
            }
            .tag_wrapper {
              margin-top: 28px;
              gap: 10px;
              .tag {
                font-size: 14px;
                line-height: 1.5;
                padding: 7px 14px;
              }
            }
            .introduce {
              font-size: 14px;
              line-height: 1.8;
              margin-top: 14px;
            }
            .video_wrapper {
              margin-top: 28px;
              .title {
                font-size: 14px;
                line-height: 1.5;
              }
              .video_duration {
                font-size: 14px;
                line-height: 1.5;
              }
            }
          }
          .add_card {
            padding-bottom: 60px;
            .description {
              font-size: 20px;
              line-height: 1.5;
            }
          }
        }
      }
      .not_data_wrapper {
        .back_btn {
          font-size: 20px;
          line-height: 1.5;
          padding: 14px 28px;
        }
      }
    }
  }
}
.index_loading {
  display: block;
  margin: 50px auto;
  .ant-spin-text {
    color: #05644f;
    margin-top: 5px;
  }
}
._video_op_wrapper_96mx8_1 {
  display: none;
}

/* 真机窄屏：简历详情弹窗改为流式宽度（800px 固定宽在 390px 视口会溢出） */
@media (max-width: 640px) {
  .resume_detail_modal {
    width: calc(100vw - 24px) !important;
    top: 120px;
  }
}
</style>

<style lang="less" scoped>
.container {
  padding: 0 5%;
  position: relative;
  .logo {
    width: 178px;
    height: 64px;
    display: block;
    margin: 16px auto;
  }
  .advertise_carousel {
    margin-left: 30px;
    margin: 40px auto;
    img {
      margin: 0 auto;
      width: auto;
      height: 240px;
      cursor: pointer;
      max-width: 100%;
    }
  }
  .search_wrapper {
    margin: 32px auto;
    display: flex;
    max-width: 1080px;
    position: relative;
    justify-content: center;
    align-items: center;
    .search {
      flex: 1;
      position: relative;
      background: #fff;
      border-radius: 20px;
      padding: 16px;
      max-width: 850px;
      .search_input {
        border: none;
        box-shadow: none;
        color: #05644f;
        font-size: 14px;
        padding: 0;
        &::placeholder {
          color: rgba(5, 100, 79, 0.3);
        }
      }
      .search_actions {
        margin-top: 15px;
        .choose_btn,
        .upload_btn {
          background: #f78335;
          border-radius: 100px;
          padding: 7px 15px;
          color: #ffffff;
          display: inline-block;
          cursor: pointer;
          margin-right: 10px;
          font-size: 12px;
        }
        .choose_icon,
        .upload_icon {
          width: 18px;
          height: 18px;
          margin-right: 5px;
          vertical-align: text-bottom;
        }
      }
      .search_icon {
        width: 20px;
        height: 20px;
        position: absolute;
        right: 20px;
        bottom: 15px;
        cursor: pointer;
      }
    }
    .suggestions_list {
      position: absolute;
      background: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
      border-radius: 8px;
      width: 100%;
      top: 100%;
      left: 0;
      z-index: 99;
      li {
        list-style: none;
        padding: 10px 20px;
        color: #05644f;
        font-size: 16px;
        cursor: pointer;
        &:hover {
          background: rgba(5, 100, 79, 0.1);
        }
        .position {
          margin-left: 20px;
          color: rgba(5, 100, 79, 0.5);
        }
      }
    }
    .file_wrapper {
      border-radius: 8px;
      padding: 16px;
      border: 1px solid rgba(5, 100, 79, 0.5);
      width: fit-content;
      display: flex;
      margin-bottom: 10px;
      .file_img {
        width: 30px;
        height: 30px;
        cursor: pointer;
        margin-top: 4px;
      }
      .file_info {
        min-width: 160px;
        margin: 0 10px;
        .file_name {
          margin-bottom: 6px;
          color: #3d3d3d;
        }
        .file_status {
          color: #05644f;
        }
      }
      .file_action_icon {
        width: 20px;
        height: 20px;
        cursor: pointer;
        margin: 10px 0;
      }
      .loading_icon {
        animation: spin 5s linear infinite;
      }
      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }
  }

  .talent_wrapper {
    margin: 50px auto;
    padding-bottom: 30px;
    position: relative;
    z-index: 1;
    .mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #cdedd6;
      z-index: 5;
    }
    .title {
      display: flex;
      align-items: center;
      font-size: 20px;
      color: #05644f;
      font-weight: 500;
      .title_icon {
        width: 12px;
        height: 20px;
        margin-right: 10px;
      }
    }
    .waterfall_wrapper {
      width: 100%;
      margin-top: 32px;
      .grid_item {
        width: calc(100% / 7);
        padding: 12px;
        box-sizing: border-box;
        .resume_card {
          background-color: #ffffff;
          border-radius: 16px;
          break-inside: avoid;
          height: fit-content;
          padding: 20px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 4px 12px rgba(0, 0, 0, 0.05);
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          cursor: pointer;
          border: 1px solid transparent;
          &:hover {
            transform: translateY(-4px);
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
            border-color: rgba(5, 100, 79, 0.1);
          }
          .info_wrapper {
            display: flex;
            position: relative;
            .avatar {
              width: 32px;
              height: 32px;
              border-radius: 50%;
              position: absolute;
              right: 0;
              object-fit: cover;
            }
            .info {
              display: flex;
              flex-wrap: wrap;
              align-content: space-around;
              .name {
                color: #3d3d3d;
                font-size: 14px;
                font-weight: 500;
                width: 100%;
                margin-bottom: 8px;
              }
              .type {
                color: #888;
                font-size: 12px;
                width: 80%;
              }
            }
          }
          .tag_wrapper {
            display: flex;
            flex-wrap: wrap;
            margin-top: 24px;
            margin-bottom: 12px;
            gap: 8px;
            .tag {
              border-radius: 100px;
              padding: 5px 10px;
              font-size: 12px;
            }
            .tag-job {
              background: rgba(5, 100, 79, 0.1);
              color: #05644f;
            }
            .tag-skill {
              background: rgba(247, 131, 53, 0.1);
              color: #f78335;
            }
          }
          .introduce {
            color: #4b5563;
            font-size: 13px;
            line-height: 1.6;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
          }
          .video_wrapper {
            margin-top: 16px;
            padding-top: 16px;
            border-top: 1px solid #f3f4f6;
            .title {
              display: flex;
              align-items: center;
              font-size: 12px;
              color: #6b7280;
              font-weight: 500;
              margin-bottom: 10px;
              .camera_icon {
                width: 14px;
                height: 14px;
                margin-right: 6px;
                opacity: 0.7;
              }
            }
            .video_card_container {
              position: relative;
              min-height: 120px;
              background: #f5f5f5;
              border-radius: 10px;
              overflow: hidden;
              margin-top: 8px;
            }
            .video_img {
              width: 100%;
              height: auto;
              border-radius: 10px;
              margin-top: 10px;
            }
            .video_player {
              width: 100%;
              display: block;
              object-fit: cover;
            }
            .video_cover_img {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 10px;
              pointer-events: none;
              transition: opacity 0.2s ease;
            }
            .video_cover_hidden {
              opacity: 0;
            }
            .video_cover_default {
              object-fit: contain;
              padding: 20%;
              background: #f5f5f5;
            }
            .video_duration {
              color: #ffffff;
              font-size: 11px;
              font-weight: 500;
              background: rgba(0, 0, 0, 0.5);
              border-radius: 4px;
              position: absolute;
              bottom: 8px;
              right: 8px;
              padding: 2px 6px;
            }
          }
        }
        .add_card {
          background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);
          border: 2px dashed #d1d5db;
          border-radius: 16px;
          text-align: center;
          padding: 40px 20px;
          transition: all 0.25s ease;
          &:hover {
            border-color: #05644f;
            background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
          }
          .add_icon_wrapper {
            width: 64px;
            height: 64px;
            margin: 0 auto 16px;
            background: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
            .add_icon {
              width: 28px;
              height: 28px;
            }
          }
          .description {
            font-size: 15px;
            font-weight: 600;
            color: #374151;
          }
        }
      }
      @media (max-width: 2560px) {
        .grid_item {
          width: calc(100% / 6);
        }
      }
      @media (max-width: 1920px) {
        .grid_item {
          width: calc(100% / 5);
        }
      }
      @media (max-width: 1440px) {
        .grid_item {
          width: calc(100% / 4);
          padding: 10px;
        }
      }
      @media (max-width: 1200px) {
        .grid_item {
          width: calc(100% / 3);
          padding: 10px;
        }
      }
      @media (max-width: 1080px) {
        .grid_item {
          width: calc(100% / 2);
          padding: 8px;
        }
      }
      // 真机窄屏（initial-scale=1）两列瀑布流 + 卡片紧凑化（用户要求一行两张简历卡）。
      // 必须写在本 scoped 块内：scoped 规则带 [data-v] 属性，特异性高于全局 style 块，
      // 写在全局块会被组件基础样式（padding:20px/字号）压制（1080 块就因此一直未生效）
      @media (max-width: 640px) {
        margin-top: 12px; // 收窄筛选胶囊与简历卡片之间的间距（桌面仍为 32px）
        .grid_item {
          width: calc(100% / 2);
          padding: 8px 6px; // 左右 6px 形成列间距，Masonry percentPosition 自适应
        }
        .grid_item .resume_card {
          padding: 14px 12px;
          .info_wrapper {
            // 头像绝对定位在卡片右上(28px)，两列卡片内容宽仅约 150px，
            // 长名字(如 Vincent Garcia)会顶进头像，info 整体让出头像宽度
            .info {
              padding-right: 34px;
              .name {
                font-size: 13px;
                margin-bottom: 4px;
              }
              .type {
                font-size: 11px;
              }
            }
            .avatar {
              width: 28px;
              height: 28px;
            }
          }
          .tag_wrapper {
            margin-top: 14px;
            margin-bottom: 8px;
            gap: 6px;
            .tag {
              font-size: 11px;
              padding: 4px 8px;
            }
          }
          .introduce {
            margin-top: 10px;
            font-size: 12px;
            line-height: 1.6;
          }
          .video_wrapper {
            margin-top: 12px;
            padding-top: 12px;
            .title {
              font-size: 11px;
            }
          }
        }
      }
    }
    .not_data_wrapper {
      text-align: center;
      color: rgba(61, 61, 61, 0.5);
      margin-bottom: 80px;
      img {
        width: 24px;
        height: 24px;
        margin-bottom: 20px;
      }
      .back_btn {
        background: #05644f;
        border-radius: 100px;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        line-height: normal;
        display: inline-block;
        width: 230px;
        padding: 10px 20px;
        height: auto;
        margin-top: 30px;
        cursor: pointer;
      }
    }
  }
}

/* 真机窄屏（initial-scale=1）首页适配 */
@media (max-width: 640px) {
  .container {
    padding: 0 12px;
    .advertise_carousel {
      margin: 20px auto;
      img {
        width: 100%;
        height: auto; // 宽幅 banner 按原比例缩放，避免被压进固定高度导致变形
      }
      // 图片等比缩放变矮后，默认叠在图内的轮播圆点会盖住广告内容：
      // dots 的包含块是内层 slick-slider（高度=图片高），用负 bottom 移到图片下方
      padding-bottom: 22px;
      &::v-deep .slick-dots {
        bottom: -24px;
        li {
          button {
            background: #05644f; // 图片外是浅绿页面背景，白点几乎不可见，改深绿
            opacity: 0.3;
          }
          &.slick-active button {
            background: #05644f;
            opacity: 1;
          }
        }
      }
    }
    .search_wrapper {
      margin: 20px auto;
    }
    .talent_wrapper {
      margin: 24px auto;
    }
    // 手机端隐藏"添加简历/AI Resume"引导卡片，避免占据首屏空间；桌面不受影响
    // 注意：两列瀑布流与卡片内部紧凑样式必须写在 scoped 块（带 [data-v] 特异性才能压过组件基础样式），
    // 见上方 .waterfall_wrapper 内的 640 媒体块
    .waterfall_wrapper {
      .add_card {
        display: none;
      }
    }
    .filter_wrapper {
      // 不用 flex gap：部分微信旧内核不识别，导致两颗胶囊贴在一起；
      // 桌面给 .ant-select-selector 设的 margin:0 10px 会让可见胶囊比容器宽 10px，
      // 恰好吃掉外层间距，窄屏必须归零，让间距完全由 margin 控制。
      // selector/checkbox 是 antd 组件内部 DOM，必须 ::v-deep 穿透 scoped
      .filter_select {
        margin-right: 16px;
        &::v-deep .ant-select-selector {
          margin: 0;
          font-size: 15px; // 收回 1080 块的 16px，保证最窄视口两颗胶囊单行放下
        }
      }
      .video_select {
        margin-left: 0;
        width: auto;
        padding: 0 12px;
        &::v-deep .ant-checkbox-wrapper {
          white-space: nowrap; // 真机字体略宽，固定宽会让勾选圆圈和文案溢出胶囊
          .ant-checkbox + span {
            font-size: 15px;
          }
        }
      }
    }
  }
}
</style>
